/** Must match CURRENT_POLICY_VERSION in backend/config/consent_config.py */
export const CURRENT_POLICY_VERSION = 1;

/**
 * Sentinel value written to `audio_url` after the underlying file has been
 * deleted by the 7-day retention scan. Must match `AUDIO_DELETED_SENTINEL` in
 * `backend/config/consent_config.py`.
 */
export const AUDIO_DELETED_SENTINEL = "__deleted_after_retention__";

export function isAudioDeletedAfterRetention(audioUrl?: string | null): boolean {
  return audioUrl === AUDIO_DELETED_SENTINEL;
}
